import fetch from 'isomorphic-fetch';
import handleAuthErrorResponse from './handleAuthError';

const API_ID_URL = process.env.REACT_APP_CORE_API_URL || `https://prod-api.vmnk.in/core-service`;
//const API_ID_URL = `http://localhost:8080`;

export default function callCoreApi(endpoint, method = 'get', body) {
    let token = window.localStorage.getItem('token') ?  window.localStorage.getItem('token') : '';
    let headers = {};
    headers['content-type'] = 'application/json';
    if (token && token !=='') {
        headers.Authorization = `Bearer ${token}`;
    }
    return fetch(`${API_ID_URL}/${endpoint}`, {
        headers: headers,
        method,
        body: JSON.stringify(body),
    })
        .then(response => response.json().then(json => ({json, response})))
        .then(({json, response}) => {
            if (handleAuthErrorResponse(json)) {
                return Promise.reject(json);
            }
            if (!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
        .then(
            response => response,
            error => error
        );
}

